import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
import {
  Typography,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Paper,
  Toolbar,
} from '@mui/material';
import { HomeIcon, SettingsIcon } from '../components/MuiIcons';
import EmojiEventsIcon from '../components/EmojiEventsIcon';
import ListItemButton from '@mui/material/ListItemButton';

const drawerWidth = 220;

const SettingsPage: React.FC = () => {
  const history = useHistory();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleMenuItemClick = (path: string) => {
    history.push(path);
    setDrawerOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Header onMenuClick={() => setDrawerOpen(true)} title="Wine War" />

      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <Toolbar />
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick('/home')}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Home" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick('/competitions')}>
              <ListItemIcon>
                <EmojiEventsIcon />
              </ListItemIcon>
              <ListItemText primary="Battles" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick('/settings')}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 4, mt: 8 }}>
        <Typography variant="h5" gutterBottom>
          Settings
        </Typography>

        <Paper sx={{ p: 3, maxWidth: 600 }}>
          <Typography variant="body1" color="text.secondary">
            Application settings coming soon...
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default SettingsPage;